import { render } from "./index.vue?vue&type=template&id=b8c129c8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b8c129c8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/cookies-bar/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b8c129c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b8c129c8', __exports__)) {
    api.reload('b8c129c8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b8c129c8", () => {
    api.rerender('b8c129c8', render)
  })

}


export default __exports__